import { Image as ImageProps } from 'src/types/Image';
import { Button } from '@get-mosh/msh-shared';
import Heading from '../Heading/Heading';
import Image from 'next/image';
import { trackClick } from 'src/analytics/Events';
import EventNames from 'src/analytics/EventNames';

const CardProductDemo = {
    name: 'Energy Libido Vitamin',
    images: [
        {
            src: '/images/products/258MOSH_eCom_Suite_FA2250ml_Tablet_Cannister_Libido_Front.png',
            width: 320,
            height: 320,
            alt: 'Mosh Energy Libido Vitamin',
        },
    ],
    details: [
        {
            label: 'quantity',
            value: '180 tablets',
        },
        { label: 'price', value: '$90/3 months' },
    ],
    cta: {
        text: 'Learn more',
        link: '#',
    },
};

export interface UpsellProps {
    title?: string;
    description?: string;
    products?: CardProductProps[];
}

const Upsell = (props: UpsellProps) => {
    return (
        <div className="container text-center">
            {props.title && (
                <Heading level="h2" className={'mb-4 block'}>
                    {props.title}
                </Heading>
            )}
            {props.description && <p className="mb-4">{props.description}</p>}
            {props.products && (
                <div className="flex flex-wrap justify-center sm:flex-nowrap sm:items-center sm:space-x-4">
                    {props.products.map((e: CardProductProps, i: number) => {
                        return (
                            <CardProduct
                                key={i}
                                {...e}
                                cta={{
                                    text: e.cta?.text,
                                    link: e.cta?.link,
                                    trackEvent: () =>
                                        trackClick(
                                            EventNames.BUTTON_LEARN_MORE_CLICKED,
                                            {
                                                label: 'CardProduct',
                                                medication: e.cta?.text,
                                                destination_url: e.cta?.link,
                                            },
                                        ),
                                }}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};

Upsell.defaultProps = {
    title: 'Not ready for medication?',
    description: 'Try our over-the-counter products',
    products: [
        { ...CardProductDemo },
        { ...CardProductDemo },
        { ...CardProductDemo },
    ],
};

export interface CardProductProps {
    name?: string;
    children?: React.ReactNode;
    className?: string;
    images: ImageProps[];
    details?: CardProductDetailsProps[];
    cta: {
        text: string;
        link: string;
        trackEvent?: () => void;
    };
}

type CardProductDetailsProps = {
    label: string;
    value: string;
};

const CardProduct = (props: CardProductProps) => {
    return (
        <article className="mb-4 w-auto rounded-lg bg-white p-4 shadow-sm">
            <header>
                {props.name && <Heading level="h3">{props.name}</Heading>}
                {props.images &&
                    props.images.map((e: ImageProps, i: number) => {
                        return (
                            <div
                                className="mx-auto mb-4 block h-32 w-32"
                                key={i}
                            >
                                <Image
                                    className="h-full w-full object-fill"
                                    src={e.src}
                                    width={e.width}
                                    height={e.height}
                                    alt={e.alt}
                                />
                            </div>
                        );
                    })}
            </header>
            <section>
                {props.details && (
                    <ul className="mb-4 flex flex-row justify-center divide-x divide-grey-300 text-center">
                        {props.details.map((e: CardProductDetailsProps) => {
                            return (
                                <li
                                    className="px-1 text-xs text-grey-400"
                                    key={e.label}
                                >
                                    <span>{e.value}</span>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </section>
            <footer>
                {props.cta && (
                    <Button
                        as="a"
                        text={props.cta.text}
                        href={props.cta.link}
                        className="w-full"
                        onClick={props.cta?.trackEvent}
                        stretch
                    />
                )}
            </footer>
        </article>
    );
};

CardProduct.defaultProps = {
    name: 'Energy Libido Vitamin',
    images: [
        {
            src: '/images/products/258MOSH_eCom_Suite_FA2250ml_Tablet_Cannister_Libido_Front.png',
            width: 320,
            height: 320,
            alt: 'Mosh Energy Libido Vitamin',
        },
    ],
    details: [
        {
            label: 'quantity',
            value: '180 tablets',
        },
        { label: 'price', value: '$90 / 3 months' },
        { label: 'asdf', value: '$90 / 3 months' },
    ],
    cta: {
        text: 'Learn more',
        link: '#',
    },
};

export default Upsell;
